document.addEventListener("DOMContentLoaded", function() {
    var headerSearch = document.querySelector('.header__icon.header__icon--search ');
    var searchInput = document.querySelector('.search__input');
    var clickTriggered = false;

    headerSearch.addEventListener('click', function(event) {
        var closeButton = document.querySelector('.search-modal__close-button');
        if (event.target === closeButton || closeButton.contains(event.target)) {
            return; 
        }

        if (!clickTriggered) {
            clickTriggered = true;
            setTimeout(function() {
                searchInput.click();
                clickTriggered = false;
            }, 250); 
        }
    });
});

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
const wizzyLazyAssetUtils = {
  isWizzyLazyLoaded: false,
  isCollectionEnabled: true,
  wizzyStore: JSON.parse(window.localStorage.getItem('wizzy_store')) ?? false,
  collectionId: document.querySelector("[data-collection-id]")?.getAttribute("data-collection-id") ?? false,
  productId: document.querySelector("[data-product-id]")?.getAttribute("data-product-id") ?? false,
  pageHandle: document.querySelector("[data-page-handle]")?.getAttribute("data-page-handle") ?? false,
  currentEle: null,
  enableWizzyAssets(targetEle = null) {
    console.log("Wizzy enable lazy assets again")
    if (!this.isWizzyLazyLoaded) {
      this.isWizzyLazyLoaded = true;
      
      window.wizzyLazyAssets.load();
    }

  },
  isValidTargetEleToEnable(targetEle) {
    return targetEle.getAttribute("name") == "q" &&
      targetEle.getAttribute("type") == "search";
  },
  clickCondition(targetEle) {
    var self = wizzyLazyAssetUtils;
    return wizzyLazyAssetUtils.isValidTargetEleToEnable(targetEle);
  },
  keyDownCondition(targetEle) {
    var self = wizzyLazyAssetUtils;
    return wizzyLazyAssetUtils.isValidTargetEleToEnable(targetEle);
  },
  handleInitClick(e) {
    var self = wizzyLazyAssetUtils;
    let targetEle = e.target;
    if (self.clickCondition(targetEle)
      &&
      !window.isWizzyLazyLoaded
    ) {
      self.currentEle = targetEle;
      self.enableWizzyAssets(targetEle);

      document.removeEventListener("click", self.handleInitClick);
    }
  },
  handleInitKeyDown(e) {
    var self = wizzyLazyAssetUtils;
    let targetEle = e.target;
    if (self.keyDownCondition(targetEle)
      &&
      !window.isWizzyLazyLoaded
    ) {
      self.currentEle = targetEle;
      self.enableWizzyAssets(targetEle);
      document.removeEventListener("keydown", self.handleInitKeyDown);
    }

  },
  attachEvents() {
    var self = wizzyLazyAssetUtils;
    document.addEventListener("click", self.handleInitClick);
    document.addEventListener("keydown", self.handleInitKeyDown);

    window.addEventListener("onWizzyScriptLoaded", () => {
      window.wizzySearchInit();
    });

    window.addEventListener("onWizzyInit", () => {
      if (self.currentEle) {
        setTimeout(() => {
          self.currentEle.click();
        }, 10);
      }
      document.removeEventListener("click", self.handleInitClick);
    });
  },
  isOnValidaProductPage() {
    let self = wizzyLazyAssetUtils;
    return self.wizzyStore
      && typeof self.wizzyStore == 'object'
      && self.wizzyStore.hasOwnProperty('CLICKED_PRODUCTS')
      && typeof self.wizzyStore['CLICKED_PRODUCTS'] == 'object'
      && self.wizzyStore['CLICKED_PRODUCTS'].hasOwnProperty(self.productId)
      ;
  },
  isOnCollectionPage() {
    let self = wizzyLazyAssetUtils;
    return self.isCollectionEnabled && self.collectionId != undefined && self.collectionId != "" && self.collectionId != null;
  },
  isNeedToAutoInitWizzy() {
    var self = wizzyLazyAssetUtils;
    console.log(self.pageHandle == "/pages/search" || self.isOnValidaProductPage() || self.isOnCollectionPage(), "<=== wizzy return");
    return self.pageHandle == "/pages/search" || self.isOnValidaProductPage() || self.isOnCollectionPage();
  },
  init() {
    var self = wizzyLazyAssetUtils;
    this.attachEvents();
    console.log(!window.wizzyConfigUpdated);
    if (!window.wizzyConfigUpdated) {
      let wizzyCategoryPageInterval = setInterval(() => {
        if (window.wizzyConfigUpdated) {
          clearInterval(wizzyCategoryPageInterval);
          if (self.isNeedToAutoInitWizzy())
            self.enableWizzyAssets();

        }
      }, 10);
    } else {
      console.log(self.isNeedToAutoInitWizzy(),"wizzy isNeedToAutoInitWizzy");
      if (self.isNeedToAutoInitWizzy())
        self.enableWizzyAssets();

    }
  },
};

window.onload = (e) => wizzyLazyAssetUtils.init();

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

const changeTemplate = (div) => {
  let newDiv = document.getElementById(div+'-new').text;
  let oldDiv =  document.getElementById(div);
  oldDiv.text = newDiv;
}

const changeTemplateMobile = (div) => {
  let newDiv = document.getElementById(div+'-new-mobile').text;
  let oldDiv =  document.getElementById(div);
  oldDiv.text = newDiv;
}

window.onWizzyScriptLoaded = function(){
  changeTemplate("wizzy-search-results-product");
  changeTemplate("wizzy-autocomplete-topproducts");
  changeTemplate("wizzy-search-sort");
  changeTemplate("wizzy-search-empty-results");

  
  if(document.documentElement.clientWidth > 768) {
    changeTemplate("wizzy-search-wrapper");   
  }else {
    changeTemplateMobile("wizzy-search-wrapper");
  }


  
  function attachListViewChangeListener() {
    let listViewElements = document.querySelectorAll(".wizzy-custom-list-change-one, .wizzy-custom-list-change-two, .wizzy-custom-list-change-three, .wizzy-custom-list-change-four");
    
    let len = listViewElements.length;
    for(let i = 0; i < len; i++) {
      let hasClickListener = listViewElements[i].onclick;
      if(!hasClickListener) {
        listViewElements[i].onclick = function(event) {

          event.preventDefault();
          if(this.classList.contains("active")) {
            return;
          }
          
          let itemsCount = this.getAttribute("data-items");

          let oneItemsEle = document.querySelector('.wizzy-custom-list-change-one');
          let twoItemsEle = document.querySelector('.wizzy-custom-list-change-two');
          let threeItemsEle = document.querySelector(".wizzy-custom-list-change-three");
          let fourItemsEle = document.querySelector(".wizzy-custom-list-change-four");
          if(oneItemsEle) oneItemsEle.classList.remove("active"), sessionStorage.setItem("wizzy-custom-list-change-1", 'false');
          if(twoItemsEle) twoItemsEle.classList.remove("active"), sessionStorage.setItem("wizzy-custom-list-change-2", 'false');
          if(threeItemsEle) threeItemsEle.classList.remove("active"), sessionStorage.setItem("wizzy-custom-list-change-3", 'false');
          if(fourItemsEle) fourItemsEle.classList.remove("active"), sessionStorage.setItem("wizzy-custom-list-change-4", 'false');
          
          this.classList.add("active");

          let productsPerRow = this.getAttribute("data-items");
          sessionStorage.setItem("wizzy-custom-list-change-" + productsPerRow, 'true');
          let parentWrapper = document.querySelector(".wizzy-search-wrapper");
          if(parentWrapper) {
            parentWrapper.setAttribute("data-wizzy-products-per-row", productsPerRow);
          }
          
        }
      }
    }
  }

  function onReloadOrCominigBackFromPDPHandleListViewChange() {
    let oneItemsEle = document.querySelector('.wizzy-custom-list-change-one');
    let twoItemsEle = document.querySelector('.wizzy-custom-list-change-two');
    let threeItemsEle = document.querySelector(".wizzy-custom-list-change-three");
    let fourItemsEle = document.querySelector(".wizzy-custom-list-change-four");
    if(oneItemsEle) oneItemsEle.classList.remove("active");
    if(twoItemsEle) twoItemsEle.classList.remove("active");
    if(threeItemsEle) threeItemsEle.classList.remove("active");
    if(fourItemsEle) fourItemsEle.classList.remove("active");

    let productsPerRow = null;
    if(sessionStorage.getItem("wizzy-custom-list-change-1") === 'true' && oneItemsEle) oneItemsEle.classList.add("active"), productsPerRow = "1";
    if(sessionStorage.getItem("wizzy-custom-list-change-2") === 'true' && twoItemsEle) console.log("<=====Two is fine"), twoItemsEle.classList.add("active"), productsPerRow = "2";
    if(sessionStorage.getItem("wizzy-custom-list-change-3") === 'true' && threeItemsEle) console.log("<=====Why  Three is fine"), threeItemsEle.classList.add("active"), productsPerRow = "3";
    if(sessionStorage.getItem("wizzy-custom-list-change-4") === 'true' && fourItemsEle) fourItemsEle.classList.add("active"), productsPerRow = "4";


    console.log(productsPerRow, "<===wizzy");
    if(productsPerRow) {
     let parentWrapper = document.querySelector(".wizzy-search-wrapper");
      if(parentWrapper) {
        parentWrapper.setAttribute("data-wizzy-products-per-row", productsPerRow);
      }
    }else if(document.documentElement.clientWidth > 768) {
      if(threeItemsEle) threeItemsEle.classList.add("active");
    }else {
      if(twoItemsEle) twoItemsEle.classList.add("active");
    }

    if(document.documentElement.clientWidth < 768) {
      sessionStorage.setItem("wizzy-custom-list-change-3", "false");
      sessionStorage.setItem("wizzy-custom-list-change-4", "false");
    }
    
  }


  window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.BEFORE_INIT, function (data) {  
    console.log(data);
    window.wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers.push(
      {
          "dom": "search__input",
          "type": "search"
      }
    );
    return data;
  })
  
  window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.PRODUCTS_RESULTS_RENDERED, function (data) {
    onReloadOrCominigBackFromPDPHandleListViewChange();
    return data;    
  });

  window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.PRODUCTS_CACHED_RESULTS_RENDERED, function (data) {
    onReloadOrCominigBackFromPDPHandleListViewChange();
    return data;    
  });


    window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_RENDER, function(data) {
    // console.log(data, "<====BEFORE_AUTOCOMPLETE_RENDER");
    let x = document.querySelector(".wizzy-body-end-wrapper");
    if(x && typeof data.isForDefault !== 'undefined' && data.isForDefault === true) {
      x.classList.add("wizzy-view-more-hide");
    }else if(x && x.classList.contains("wizzy-view-more-hide")) {
      x.classList.remove("wizzy-view-more-hide");
    }
    return data;
  })
  
  
   window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.VIEW_RENDERED,
    function (data) {
      window.initAtcBtns();
      attachListViewChangeListener();      
      return data;
    }
  );


  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_WIZZY_API_RESPONDED,
    function (data) {
      // console.log(data);
      const sizeOrder = ['XS', 'S', 'M', 'L', 'XL', '2XL', '3XL', '4XL', '5XL', '6XL'];

      console.log(data.response)
      if(data.response.payload.facets) {
        const sizesFacet = data.response.payload.facets.find(facet => facet.key === "product_Size");
        // console.log(sizesFacet,"wizzy size facet data");
        // console.log("wizzy sizesFacet",sizesFacet.data);
        if (sizesFacet && sizesFacet.data && sizesFacet.data.length > 0) {
          console.log("wizzy if executed");
          const customSort = (a, b) => {
            const aIndex = sizeOrder.indexOf(a.key.toUpperCase());
            const bIndex = sizeOrder.indexOf(b.key.toUpperCase());
            return aIndex - bIndex;
          };    
          sizesFacet.data.sort(customSort);
          // console.log("wizzy data -->",sizesFacet.data);
        } else {
          console.log('wizzy No swatches available.');
        }
      }

      if(data.response.payload.facets){
        data.response.payload.facets.forEach(facet => {
            if (facet.data && Array.isArray(facet.data) && facet.key !== "sellingPrice" && facet.key !== "product_Size") {
                facet.data.sort((a, b) => {
                    // Compare the "key" property for sorting
                    const keyA = a.key.toUpperCase();
                    const keyB = b.key.toUpperCase();
        
                    if (keyA < keyB) {
                        return -1;
                    }
                    if (keyA > keyB) {
                        return 1;
                    }
                    return 0;
                });
            }
        });
      }
      
      return data;
      
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
    function (data) {
      // console.log(data);
      const sizeOrder = ['XS', 'S', 'M', 'L', 'XL', '2XL', '3XL', '4XL', '5XL', '6XL'];
      
      data.forEach((product) => {
        if(product.swatches){
          const sizesFacet = product.swatches.find(facet => facet.key === "product_Size");;
        if(sizesFacet){
          const customSort = (a, b) => {
          const aIndex = sizeOrder.indexOf(a.value);
          const bIndex = sizeOrder.indexOf(b.value);      
          return aIndex - bIndex;
        };
        
        sizesFacet.sort(customSort);
        }
        }
      })
      return data;
    });

}
